export default __webpack_public_path__ + "static/PC_4_3-1ca31677917ce07ac5d703ca99796214.png";